import { MutableRefObject, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface ScrollToOptions {
  tolerance?: number;
  behavior?: ScrollBehavior;
}

export const useScrollTo = <T extends unknown>(
  ref: MutableRefObject<T>,
  options?: ScrollToOptions
) => {
  const { hash } = useLocation();
  const scrollToId = hash.substring(1);

  useEffect(() => {
    const element = Array.isArray(ref?.current)
      ? ref.current.find((row) => row.id === scrollToId)
      : ref.current;

    const { offsetTop = 0, id } = element || {};
    const { tolerance, behavior } = options || {};

    let position = offsetTop;

    if (tolerance) {
      position = offsetTop - tolerance;
    }

    if (scrollToId === id) {
      window.scrollTo({
        top: position,
        left: 0,
        behavior: behavior || 'smooth',
      });
    }
  }, [ref, scrollToId, options]);

  return ref;
};
